import type {
  CanvasApi,
  CanvasCreateResponseApi,
} from 'api-typings/canvas/canvas';
import type { Canvas } from './canvas.model';

/**
 * Transforms the Canvas object from the POST response to the Canvas model,
 * where `created_by` and `created_at` are not included in the response.
 */
export function transformCanvas(canvas: CanvasCreateResponseApi): Canvas {
  return {
    id: canvas.id,
    contextId: canvas.context_id,
    contextType: canvas.context_type,
  };
}

/**
 * Transforms the Canvas object from the GET response to the Canvas model,
 * where `created_by` and `created_at` are included in the response.
 */
export function transformCanvasGet(canvas: CanvasApi): Canvas {
  return {
    id: canvas.id,
    contextId: canvas.context_id,
    contextType: canvas.context_type,
    createdBy: canvas.created_by,
    createdAt: canvas.created_at * 1000,
    title: canvas.title,
  };
}
